import React from "react";

const SideImage: React.FC = () => {
  return (
    <div className="w-full lg:w-1/2 h-[300px] lg:h-auto">
      {/* <img
        src="/image.png"
        alt="Signup Visual"
        className="w-full h-full object-cover"
      /> */}
    </div>
  );
};

export default SideImage;